module.exports = __webpack_public_path__ + "img/418.745cb166.jpg";